import { Widget } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React, { forwardRef, ReactElement, useMemo } from 'react';
import { Accordion } from 'semantic-ui-react';
import { AccordionWidgetData } from '../../../models/RiskProducts';
import ExpandableMetric from '../common/ExpandableMetric';
import { getFundamentalsData } from './FundamentalsWidget.logic';
import { FundamentalsProps } from './FundamentalsWidget.types';
import styles from '../AcordionList.module.scss';

const cx = classNames.bind(styles);
const FundamentalsWidget = (
  { fundamentalsMetrics, print, ...sortableWidgetProps }: FundamentalsProps,
  ref
): ReactElement | null => {
  const fundamentalsData = useMemo(() => {
    return getFundamentalsData(fundamentalsMetrics);
  }, [fundamentalsMetrics]);

  const areChildrenEmpty = (metric: AccordionWidgetData): boolean => {
    return metric.children.every((item) => item.value == null);
  };

  const renderFundamentals = () => {
    return fundamentalsData.map((metric) => {
      return (
        <ExpandableMetric
          key={`fundamentals-${metric.item.label}`}
          isItemExpanded={!areChildrenEmpty(metric)}
          isTitleValueShown={false}
          metric={metric}
          print={print}
        />
      );
    });
  };

  const renderNotes = () => {
    return (
      <div className={cx('notes')}>
        <div className={cx('text')}>All figures in millions of USD</div>
      </div>
    );
  };

  return (
    <Widget headerTitle="Fundamentals" dataTestId="fundamentals-widget" ref={ref} {...sortableWidgetProps}>
      <div className={cx('body')} data-testid="fundamentals-content">
        <div className={cx('containers')}>
          <Accordion exclusive={false}>{renderFundamentals()}</Accordion>
          <div className={cx('notes-container')}>{renderNotes()}</div>
        </div>
      </div>
    </Widget>
  );
};

export default forwardRef(FundamentalsWidget);
